module.exports = __webpack_public_path__ + "media/images/Metal-Bar-Simple-1920px-14ee7160a5e22446bf330273859c448b.png";